import { render, staticRenderFns } from "./ALFolderForm.vue?vue&type=template&id=6ef50704&scoped=true"
import script from "./ALFolderForm.vue?vue&type=script&lang=js"
export * from "./ALFolderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef50704",
  null
  
)

export default component.exports